import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=588a24ab&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=js&"
export * from "./EditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a24ab",
  null
  
)

export default component.exports